<goab-text
  tag="h3"
  size="heading-s"
  mb="none"
  [attr.data-testid]="'reasons-for-change-heading'"
  class="reasons-for-change"
  >Reason(s) for change in number of operational beds</goab-text
>

<mat-form-field
  appearance="fill"
  class="reasons-selector"
  data-testid="reasons-selector"
>
  <mat-select
    class="reasons-select"
    appearance="fill"
    multiple
    [placeholder]="'Please select reason(s) for change'"
    [value]="selectedReasons()"
    name="reasons"
    [attr.data-testid]="'reasons-for-change'"
    [disabled]="disabled()"
    (openedChange)="onOpenedChange($event)"
    (valueChange)="onValueChange($event)"
  >
    <mat-select-trigger>
      <span *ngIf="selectedReasons()?.length">
        {{ selectedReasons().length | numberToWords : 'option' }}
        selected</span
      ></mat-select-trigger
    >
    <mat-option
      *ngFor="let reason of reasons"
      [value]="reason"
      class="list-of-reasons"
    >
      {{ reason }}
    </mat-option>
  </mat-select>
</mat-form-field>
